import { EnumFeatureFlag } from "@/app/services/generated/enums/enumFeatureFlag.generated";
import type { User } from "@/app/services/generated/userService";
import userStore from "@/store/modules/userStore";
import type { DeepReadonly } from "vue";

const supportOnlyFlags = [EnumFeatureFlag.showSupportFunctions];

export function hasFeatureUsingUserStore(
  featureFlag: EnumFeatureFlag
): boolean {
  return userStore.state.tenant && userStore.state.user
    ? hasFeature(
        featureFlag,
        userStore.state.tenant?.featureFlags ?? [],
        userStore.state.user
      )
    : false;
}
export function hasFeature(
  featureFlag: EnumFeatureFlag,
  tenantFeatureFlags: readonly EnumFeatureFlag[],
  user: DeepReadonly<User>
): boolean {
  // Add features from tenant (features we want to enable for customers on a case by case basis)
  let availableFeatures: EnumFeatureFlag[] = [...tenantFeatureFlags];

  // Add features granted by email domain (useful for testing of new features by developers).
  if (user.email.includes("@premiersystems.com")) {
    const premierDomainFlags = EnumFeatureFlag.getValues().filter(
      (flag) => !supportOnlyFlags.includes(flag)
    );

    availableFeatures.push(...premierDomainFlags);
  }

  // Add features granted by support function. A feature flag test for support functions.
  if (user.readOnly.isSupportUser) {
    availableFeatures.push(...supportOnlyFlags);
  }

  return availableFeatures.some((ff) => ff.key === featureFlag.key);
}
